import { useMemo, useState } from "react";
import "./App.css";
import { AppState } from "./types/AppState";
import { State, StateContext } from "./context/StateContext";
import rossLogo from "./assets/ross.png";
import Contents from "./components/Contents";
import {
  AboutPageWrapper,
  AppContent,
  AppLogo,
  AppLogoWrapper,
  AppWrapper,
  ContentWrapper,
  Footer,
  MainContainer,
} from "./AppStyled";
import { AboutPage, Button } from "@rv/aura-web";
import labels from "./translation/index.json";
import AboutTab from "./components/AboutTab";
import TermsTab from "./components/TermsTab";
import { FunctionComponent, ReactNode } from "react";
import libraryData from "./translation/libraries.json";

type TabState = {
  text: string;
  /**
   * @deprecated Use JSX and pass your properties directly to the component
   * See examples in aura-web and aura-petals
   */
  data?: any;
  /**
   * @deprecated Use Content instead
   */
  content?: ReactNode;
  Content?: FunctionComponent;
};

const libraryMap: string[] = Object.keys(libraryData);
const libraryTabList: Record<string, TabState> = {};

function App() {
  const [currentState, setCurrentState] = useState<AppState>({
    status: "provide-file",
  });
  const [modalType, setModalType] = useState<boolean>(false);
  const [aboutActiveTabID, setAboutActiveTabID] = useState<string>("Tab 1");
  const [licenseContent, setLicenseContent] = useState<string>(
    libraryData[libraryMap[0] as keyof typeof libraryData].description,
  );
  const [selectedLib, setSelectedLib] = useState<string>(libraryMap[0]);
  const [subActiveTabID, setSubActiveTabID] = useState<string>(
    Object.keys(libraryTabList)[0],
  );
  const state = useMemo<State>(() => {
    return { currentState, updateState: setCurrentState };
  }, [currentState]);

  return (
    <StateContext.Provider value={state}>
      <AppWrapper className="app">
        <AppContent className="app-content">
          <AppLogoWrapper>
            <AppLogo src={rossLogo} alt="Ross Logo" />
          </AppLogoWrapper>
          <ContentWrapper>
            <MainContainer>
              <Contents />
            </MainContainer>
          </ContentWrapper>
          <Footer>
            {labels.copyrightText} {new Date().getFullYear()}
            <p onClick={() => setModalType(true)}>{labels.about}</p>
          </Footer>
        </AppContent>
      </AppWrapper>

      <AboutPageWrapper>
        <AboutPage
          tabsState={{
            tabs: {
              "Tab 1": {
                text: labels.aboutwOLT,
                Content: () => <AboutTab />,
              },
              "Tab 2": {
                text: labels.termsOfUse,
                Content: () => <TermsTab />,
              },
              "Tab 3": {
                text: "License Agreements",
                Content: () => (
                  <div
                    style={{
                      height: "100%",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="lib-map">
                      {libraryMap.map((library) => (
                        <Button
                          label={
                            library.length > 14
                              ? `${library.substring(0, 14)}...`
                              : library
                          }
                          onClick={() => {
                            setLicenseContent(
                              libraryData[library as keyof typeof libraryData]
                                .description,
                            );

                            setSelectedLib(library);
                            setSubActiveTabID(library);
                          }}
                          variant="outline"
                          key={library}
                          backgroundColor={
                            selectedLib === library
                              ? "rgb(65 162 225 / 50%)"
                              : ""
                          }
                        />
                      ))}
                    </div>

                    {licenseContent && (
                      <div
                        className="license-content"
                        dangerouslySetInnerHTML={{ __html: licenseContent }}
                      />
                    )}
                  </div>
                ),
              },
            },
            activeTabID: aboutActiveTabID,
          }}
          isOpen={modalType}
          setIsOpen={setModalType}
          onChange={(newTabsState: { activeTabID: string }) => {
            setAboutActiveTabID(newTabsState.activeTabID);
          }}
        />
      </AboutPageWrapper>
    </StateContext.Provider>
  );
}

export default App;
